import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, vModelRadio as _vModelRadio, toDisplayString as _toDisplayString, withModifiers as _withModifiers, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0878f56b"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "order-container" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "order-title" }, "Schedule a Pickup", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "order-subtitle" }, null, -1))
const _hoisted_4 = ["onSubmit"]
const _hoisted_5 = { class: "form-group" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "clientName" }, "Client Name *", -1))
const _hoisted_7 = { class: "form-group" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "pickupAddress" }, "LOAD Pickup Address *", -1))
const _hoisted_9 = { class: "form-group" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "email" }, "Email *", -1))
const _hoisted_11 = { class: "form-group" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Select One of the Following For Disposal", -1))
const _hoisted_13 = { class: "service-options" }
const _hoisted_14 = { class: "service-option" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "service-label" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "service-name" }, "Logs"),
  /*#__PURE__*/_createElementVNode("span", { class: "service-price" }, "$600")
], -1))
const _hoisted_16 = { class: "service-option" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "service-label" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "service-name" }, "Brush"),
  /*#__PURE__*/_createElementVNode("span", { class: "service-price" }, "$600")
], -1))
const _hoisted_18 = { class: "service-option" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "service-label" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "service-name" }, "Stumps"),
  /*#__PURE__*/_createElementVNode("span", { class: "service-price" }, "$1000")
], -1))
const _hoisted_20 = ["disabled"]

import { ref, reactive } from 'vue';
import TheHeader from '../components/TheHeader.vue';
import TheFooter from '../components/TheFooter.vue';
import BaseContainer from '../components/BaseContainer.vue';
import { sheetdbService } from '../services/sheetdbService';

interface FormData {
    clientName: string;
    pickupAddress: string;
    email: string;
    serviceType: string;
    phone: string;
    notes: string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'OrderView',
  setup(__props) {

const isSubmitting = ref(false);
const submitMessage = ref('');
const submitMessageType = ref('');

const formData = reactive<FormData>({
    clientName: '',
    pickupAddress: '',
    email: '',
    serviceType: '',
    phone: '',
    notes: ''
});

const submitOrder = async (): Promise<void> => {
    isSubmitting.value = true;
    submitMessage.value = '';
    
    try {
        // Submit to SheetDB
        const result = await sheetdbService.submitFormData(formData);
        console.log('RESULT: ', result);
        if (result.success) {
            submitMessage.value = result.message;
            submitMessageType.value = 'success';
            
            // Reset form
            Object.assign(formData, {
                clientName: '',
                pickupAddress: '',
                email: '',
                serviceType: '',
                phone: '',
                notes: ''
            });
        } else {
            submitMessage.value = result.message;
            submitMessageType.value = 'error';
        }
    } catch (error) {
        console.error('Error submitting order:', error);
        submitMessage.value = 'Error submitting order. Please try again or contact us directly.';
        submitMessageType.value = 'error';
    } finally {
        isSubmitting.value = false;
    }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(TheHeader),
    _createVNode(BaseContainer, null, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _hoisted_2,
          _hoisted_3,
          _createElementVNode("form", {
            onSubmit: _withModifiers(submitOrder, ["prevent"]),
            class: "order-form"
          }, [
            _createElementVNode("div", _hoisted_5, [
              _hoisted_6,
              _withDirectives(_createElementVNode("input", {
                id: "clientName",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formData.clientName) = $event)),
                type: "text",
                required: "",
                class: "form-input",
                placeholder: "Enter your full name"
              }, null, 512), [
                [_vModelText, formData.clientName]
              ])
            ]),
            _createElementVNode("div", _hoisted_7, [
              _hoisted_8,
              _withDirectives(_createElementVNode("textarea", {
                id: "pickupAddress",
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formData.pickupAddress) = $event)),
                required: "",
                class: "form-input",
                placeholder: "Enter your pickup address",
                rows: "3"
              }, null, 512), [
                [_vModelText, formData.pickupAddress]
              ])
            ]),
            _createElementVNode("div", _hoisted_9, [
              _hoisted_10,
              _withDirectives(_createElementVNode("input", {
                id: "email",
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((formData.email) = $event)),
                type: "email",
                required: "",
                class: "form-input",
                placeholder: "Enter your email address"
              }, null, 512), [
                [_vModelText, formData.email]
              ])
            ]),
            _createElementVNode("div", _hoisted_11, [
              _hoisted_12,
              _createElementVNode("div", _hoisted_13, [
                _createElementVNode("label", _hoisted_14, [
                  _withDirectives(_createElementVNode("input", {
                    type: "radio",
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((formData.serviceType) = $event)),
                    value: "logs",
                    required: ""
                  }, null, 512), [
                    [_vModelRadio, formData.serviceType]
                  ]),
                  _hoisted_15
                ]),
                _createElementVNode("label", _hoisted_16, [
                  _withDirectives(_createElementVNode("input", {
                    type: "radio",
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((formData.serviceType) = $event)),
                    value: "brush",
                    required: ""
                  }, null, 512), [
                    [_vModelRadio, formData.serviceType]
                  ]),
                  _hoisted_17
                ]),
                _createElementVNode("label", _hoisted_18, [
                  _withDirectives(_createElementVNode("input", {
                    type: "radio",
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((formData.serviceType) = $event)),
                    value: "stumps",
                    required: ""
                  }, null, 512), [
                    [_vModelRadio, formData.serviceType]
                  ]),
                  _hoisted_19
                ])
              ])
            ]),
            _createElementVNode("button", {
              type: "submit",
              class: "submit-btn",
              disabled: isSubmitting.value
            }, _toDisplayString(isSubmitting.value ? 'Submitting...' : 'Submit Pickup'), 9, _hoisted_20)
          ], 40, _hoisted_4),
          (submitMessage.value)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: _normalizeClass(["submit-message", submitMessageType.value])
              }, _toDisplayString(submitMessage.value), 3))
            : _createCommentVNode("", true)
        ])
      ]),
      _: 1
    }),
    _createVNode(TheFooter)
  ], 64))
}
}

})